// extracted by mini-css-extract-plugin
export default {"Text":"ClientInformation_Text__iVS45","Layout":"ClientInformation_Layout__i-3Kj","Column":"ClientInformation_Column__-Y6YM"};